import { IMenuItem, IMenuItemOptionChoice } from "./menu";

export interface ICartItem {
	id?: string;
	menuItemId: number;
	menuItem: IMenuItem;
	quantity: number;
	price: number;
	options: {
		[key: string]: IMenuItemOptionChoice;
	};
}

export const paymentMethods = {
	"Genius Points": "Genius Points" as const,
	Cash: "Cash" as const,
	"Bank Transfer": "Bank Transfer" as const,
	FPS: "FPS" as const,
	Cheque: "Cheque" as const,
	Octopus: "Octopus" as const,
	Payme: "Payme" as const,
	AE: "AE" as const,
	EPS: "EPS" as const,
	"Union QE": "Union QE" as const,
	Alipay: "Alipay" as const,
	"Wechat Pay": "Wechat Pay" as const,
	Visa: "Visa" as const,
	Master: "Master" as const,
	"Union(CUP)": "Union(CUP)" as const,
	"Received by bosses": "Received by bosses" as const,
};

export type PaymentMethod = keyof typeof paymentMethods;
